// extracted by mini-css-extract-plugin
export default {"buttons":"priceAttr_buttons__r-u3C"};